"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useEventHandler_1 = require("../utils/useEventHandler");
var NsInputter = function (_a) {
    var value = _a.value, validation = _a.validation, ignoreSeparator = _a.ignoreSeparator, isHelperOpen = _a.isHelperOpen, execute = _a.execute, helper = _a.helper, labelID = _a.labelID, heading = _a.heading, mask = _a.mask, separator = _a.separator, name = _a.name, children = _a.children, className = _a.className, onChange = _a.onChange;
    var ref = react_1.default.useRef();
    (0, useEventHandler_1.useEventHandler)(ref, 'change', onChange);
    return (react_1.default.createElement("ns-inputter", { ref: ref, "open-helper": isHelperOpen, class: className, value: value, validation: validation, ignoreseparator: ignoreSeparator, execute: execute, helper: helper, labelID: labelID, heading: heading, mask: mask, separator: separator, name: name }, children));
};
exports.default = NsInputter;
